import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { NumbersInfoStyled } from './NumbersInfoStyled';
import classnames from 'classnames';
import styles from './numbersInfo.less?modules';
import { fmtPercentUpDown, fmtThousand, transNum } from '@/utils/comUtil';
import Member from '@/assets/img/bizgrowth/member.png';
import ActiveMember from '@/assets/img/bizgrowth/activeMember.png';

const NumbersInfo = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const {
    title = '会员数',
    vipCount = 0,
    count = 0,
    day = 0,
    dayRate = 0,
    week = 0,
    weekRate = 0,
    month = 0,
    monthRate = 0,
    cycleList,
    classname,
    hidden,
  } = props;
  return (
    <NumbersInfoStyled
      theme={themeContext}
      className={styles.box}
      brand={brandContext}
    >
      <div className={styles.box_r1}>
        <div className={styles.box_r1_c1}>
          {title === '会员数' && <img src={Member} alt="" />}
          {title === '活跃会员数' && <img src={ActiveMember} alt="" />}
          <span className={'label_t'}>{title || ''}</span>
        </div>
      </div>
      <div className={styles.box_r2}>
        <div className={styles.box_r2_c1}>
          <span className={'label_p'}>1{cycleList[0]}</span>
          <span className={'label_p'}>7{cycleList[0]}</span>
          <span className={'label_p'}>30{cycleList[0]}</span>
        </div>
        <div className={styles.box_r2_c2}>
          <span className={classnames('no_num')}>{transNum(day)}</span>
          <span className={classnames('no_num')}>{transNum(week)}</span>
          <span className={classnames('no_num')}>{transNum(month)}</span>
        </div>
        <div className={styles.box_r2_c3}>
          <p>
            <span className={'value_t'}>{fmtThousand(count) || '--'}</span>
            <span className={'vip_count'}>
              其中VIP数量：{fmtThousand(vipCount) || '--'}
            </span>
          </p>
          <div className={styles.box_r1_c2 + ' ' + classname}>
            <span className={classnames('no_number')}>
              {!hidden && (
                <span
                  className={classnames(
                    dayRate > 0 ? 'up_number' : 'down_number',
                  )}
                >
                  {fmtPercentUpDown(dayRate) || '--'}
                </span>
              )}
              {!hidden && (
                <span
                  className={classnames(
                    weekRate > 0 ? 'up_number' : 'down_number',
                  )}
                >
                  {fmtPercentUpDown(weekRate) || '--'}
                </span>
              )}

              {!hidden && (
                <span
                  className={classnames(
                    monthRate > 0 ? 'up_number' : 'down_number',
                  )}
                >
                  {fmtPercentUpDown(monthRate) || '--'}
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
      {/* <img src={Divider} alt="" className={'divider'} /> */}
    </NumbersInfoStyled>
  );
};
export default NumbersInfo;
